// Just here to keep things DRY
import { Capacitor } from '@capacitor/core';

export const isPhoneGap = Capacitor.getPlatform() !== 'web';
